<style>

.bar{
  position: fixed;
  z-index: 50;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50px;
  display: grid;
  grid-template-columns: 15% 25% 20% 20% 20%;
  box-shadow: 0 -2px 5px rgb(0,0,0);
  text-align: center;
  background-color: rgba(0,0,0,0.8);
  color: #ccc;
}
.button1{ grid-column: 1; font-size: 30px; padding-top: 10px; padding-left: 10px;}
.button2{ grid-column: 2; font-size: 30px; padding-top: 10px;}
.button3{ grid-column: 3; font-size: 30px; padding-top: 4px;}
.button4{ grid-column: 4; font-size: 28px; padding-top: 10px; padding-left: 18px;}
.button5{ grid-column: 5; font-size: 30px; padding-top: 5px;}
.main{
  background-color: white;
  color: black;
  border-radius: 50px;
  padding-top: 5px;
}

.profile-pic{
  width: 40px;
  border-radius: 40px;
}
</style>

<div class="bar">
  <div class="button1" on:click="{ () => { push('/find-friends') } }"><i class="icon-person_add"></i></div>
  <div class="button2" on:click="{ () => { push('/search')  } }"><i class="icon-search"></i></div>
  <div class="button3" on:click="{ () => { push('/events') } }">
    <div class="main">
      <i class="icon-home"></i>
    </div>
  </div>
  <div class="button4" on:click="{ () => { push('/friends') } }"><i class="icon-send"></i></div>
  <div class="button5" on:click="{ () => { push('/profile') } }"><img src="/i/alison-james-small.jpg" alt="profile pic" class="profile-pic"></div>
</div>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

</script>